import { createFileRoute, redirect } from "@tanstack/react-router"

import { deploymentPath } from "@/config"

export const Route = createFileRoute("/_no-auth/auth-failed/")({
  beforeLoad: async ({ context: { authClient } }) => {
    // Disabled or unresolved custom domain: _authlayout sends us here, so redirecting home would loop.
    if (deploymentPath.customKey && !authClient.getCustomization()?.url_enabled) {
      return
    }

    if (await authClient.isAuthenticated()) {
      redirect({
        to: "/",
        throw: true
      })
    }
  },
  head: () => ({
    meta: [
      {
        title: "Auth Failed | Arduino Cloud"
      }
    ]
  })
})
